export default __webpack_public_path__ + "static/media/clickHi.9643c745.mp3";